import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import SLPPriority, { SLPPriorityRef, PriorityItem } from 'utilities/slp/priority/priority.index';
import { createQuestionTitle } from '../questionsTypes.script';
import { extractTitle } from 'scripts/string';

const SLPPriorityQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPPriorityRef>(null);
    const [items, setItems] = useState<PriorityItem[]>([]);
    const [title, setTitle] = useState(question.title);

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);
    useEffect(() => {
        const temp: PriorityItem[] = [];
        question.children
            ?.sort((a, b) => a.order - b.order)
            .map((i) =>
                temp.push({
                    title: i.title,
                    payload: i.id,
                    image: i.image_file,
                    value: i.order,
                }),
            );

        const defaultValue: PriorityItem[] = [];
        if (question.children?.length) {
            question.children.map((child) => {
                const index = props.answerList?.findIndex((i) => i.question.id === child.id);
                if (index !== undefined && index > -1) {
                    const value = props.answerList[index].value;
                    if (value) {
                        defaultValue.push({
                            title: child.title,
                            payload: child.id,
                            value: Number(value),
                        });
                    }
                }
            });
        }

        setItems(defaultValue.length ? defaultValue : temp);
    }, []);

    function validate(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (question.is_required && value && value?.length < 1) {
            if (e) inputRef.current?.setError(lang.priEmp);
            return false;
        }
        return true;
    }

    function setAnswer() {
        const values = inputRef.current?.getValue();
        if (values) setItems(values);
        const data = [...props.answerList];
        values?.map((value) => {
            setTimeout(() => {
                // to avoid two same answer items id
                const child = question.children?.find((i) => i.id === Number(value.payload));
                const indexChild = props.answerList?.findIndex((i) => i.question.id === child?.id);
                if (child && indexChild) {
                    if (value && validate()) {
                        const response: AnswerItem = {
                            value: value.value.toString(),
                            question: child,
                            id: new Date().getTime(),
                            answer: props.answer?.id,
                        };
                        indexChild !== undefined && indexChild > -1
                            ? (data[indexChild] = response)
                            : data?.push(response);
                    } else if (indexChild !== undefined && indexChild > -1) data.splice(indexChild, 1);
                }
            }, 100);
        });
        props.setAnswerList(data);
    }

    function onSubmit(e?: boolean) {
        const values = inputRef.current?.getValue();
        // if user don't touch items, set answerList anyway
        setAnswer();
        if (values?.length && validate(e)) {
            for (let i = 0; i < values.length; i++) {
                const value = values[i];
                const question = props.question.children?.find((item) => item.id === value.payload);
                if (question) {
                    props.submit({
                        value: value.value.toString(),
                        question: question,
                        id: new Date().getTime(),
                        created_at: new Date().toISOString(),
                    });
                }
            }
        }
    }

    return (
        <SLPPriority
            hint={extractTitle(hint, false, false)}
            ref={inputRef}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            initialItems={items}
            color={props.form?.answer_color}
            labelColor={props.form?.question_color}
            onChange={setAnswer}
            required={question.is_required}
            dir={props.form.direction}
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPPriorityQuestion));
